import { drawLabel } from "./drawLabel";

const drawTrigger = (container, data, onDrag) => {
  const bindingData = data
    ? [data]
    : container.datum()
      ? [container.datum()]
      : [];
  const tline = container.selectAll("line.trig").data(bindingData);
  tline
    .enter()
    .append("line")
    .classed("trig", true)
    .merge(tline)
    .attr("x1", 10)
    .attr("y1", -5)
    .attr("x2", 10)
    .attr("y2", (d) => d.size.height + 5);
  tline.exit().remove();

  const tpath = container.selectAll("path.trig").data(bindingData);
  tpath
    .enter()
    .append("path")
    .classed("trig", true)
    .merge(tpath)
    .attr(
      "d",
      `M0,0  l5,0 l3,3 l7,0 v-3 l5,5  l-5,5 v-3 l-7,0 l-3,3 l-5,0 l3,-5 Z`
    );
  tpath.exit().remove();

  drawLabel(container, data, onDrag);
};

export { drawTrigger };
